import { ApolloError } from '@apollo/client'
import type { GraphQLFormattedError } from 'graphql/index'
import { useEffect } from 'react'

import { useValidateOabModalContext } from '../context'

type UseHandleValidationErrorsProps = {
  isOabValid: boolean | null | undefined
  error: ApolloError | undefined
}

export interface ValidateOabError extends GraphQLFormattedError {
  info?: {
    formattedKey: string
    key: string
    message: string
    emailConflicted?: string
  }
}

export function useHandleValidationErrors(props: UseHandleValidationErrorsProps) {
  const { goNextSuccessStep, goNextErrorStep, setEmailConflicted } = useValidateOabModalContext()
  const { isOabValid, error } = props

  useEffect(() => {
    if (isOabValid) {
      goNextSuccessStep()
    } else if (error || (typeof isOabValid === 'boolean' && !isOabValid)) {
      const maybeErrorWithKey = error?.graphQLErrors.find(
        (e: ValidateOabError): e is ValidateOabError => !!e.info?.key
      )
      const errorKey = maybeErrorWithKey?.info?.key || ''
      if (maybeErrorWithKey?.info?.emailConflicted) {
        setEmailConflicted(maybeErrorWithKey.info.emailConflicted)
      }
      if (error && !errorKey) {
        console.error('Unknown error while validating OAB:', error.cause)
      }
      goNextErrorStep(errorKey)
    }
  }, [isOabValid, error, goNextErrorStep, goNextSuccessStep, setEmailConflicted])
}
